export const environment = {
	production: false,
  baseAPIURL: 'https://lios.dev.portal.toyotasupplier.com:4444/liosop/eboiapi/api/v1',
    //'https://dev.api.subprod.newlios.toyota.com/eboi/api/v1',
	TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
	CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
	REDIRECT_URL: "https://dev.eboi.subprod.newlios.toyota.com/",
	LIOS_HOME_URL: 'https://dev.subprod.newlios.toyota.com/',
	APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
	SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
	FILE_UPLOAD_URI: "https://dev.upload.subprod.newlios.toyota.com",
	WEBSOCKET_URI: "wss://2u2u4khebk.execute-api.us-east-1.amazonaws.com/dev/",
	TEMPLATE_EXCEL_URI: "https://dev.template.subprod.newlios.toyota.com",
	TASK_MANAGER: 'https://liosapps.qa.toyota.com/task',
	AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
	ALARMS: 'https://alarms.dev.lios.toyota.com',
	FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
	CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
	COST_PLANNING: 'https://costplanning.dev.lios.toyota.com',
	EBOI: 'https://dev.eboi.subprod.newlios.toyota.com',
	TLD: 'https://liosapps.qa.toyota.com/tld/home',
	DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
	REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
	EXPORT: 'https://liosapps.qa.toyota.com/export',
	GROUPI: 'https://dev.groupi.subprod.newlios.toyota.com',
	SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
	SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
	TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
	ALLO: 'https://ts.stage.portal.toyotasupplier.com/lios/alloindex#/alloextracts',
};
